<ng-container
    *ngTemplateOutlet="
        !config.noEncapsulate ? encapsulateTpl : noEncapsulateTpl
    "
></ng-container>

<ng-template #encapsulateTpl>
    <div
        class="card"
        role="complementary"
        [attr.aria-labelledby]="config.id"
    >
        <!--TODO revise aria-->
        <div
            class="card-header"
            [id]="config.id"
            role="heading"
            aria-level="2"
        >
            {{ config.header }}
        </div>
        <div class="card-body">
            <ng-template #container></ng-template>
        </div>
    </div>
</ng-template>

<ng-template #noEncapsulateTpl>
    <ng-template #container></ng-template>
</ng-template>
